module.exports = __webpack_public_path__ + "e4393b4fa41185600cbf436b663ac37a.pdf";